import UserTasks from "../components/UserTasks";

export const UserTasksPage = () => {
  return (
    <div>
      <UserTasks />
    </div>
  );
};

export default UserTasksPage;
